import Vue from 'vue';
//新创建一个vue实例
let v = new Vue();
export default {
    // 公共的js方法
    getTimeStr (val) {
        if (!val) { return }
        let now = new Date(val)
        let yy = now.getFullYear();
        let mm = now.getMonth() + 1;
        let dd = now.getDate();
        let hh = now.getHours();
        let ii = now.getMinutes();
        let ss = now.getSeconds();
        let clock = yy + "-";
        if (mm < 10) clock += "0";
        clock += mm + "-";
        if (dd < 10) clock += "0";
        clock += dd + " ";
        if (hh < 10) clock += "0";
        clock += hh + ":";
        if (ii < 10) clock += '0';
        clock += ii + ":";
        if (ss < 10) clock += '0';
        clock += ss;
        return clock;
    },
    getDateStr (val) {
        if (!val) { return }
        let now = new Date(val)
        let yy = now.getFullYear();
        let mm = now.getMonth() + 1;
        let dd = now.getDate();
        let clock = yy + "-";
        if (mm < 10) clock += "0";
        clock += mm + "-";
        if (dd < 10) clock += "0";
        clock += dd + " ";
        return clock;
    },
    formatDate (val) {
        if (!val) { return }
        let now = new Date(val)
        let yy = now.getFullYear();
        let mm = now.getMonth() + 1;
        let dd = now.getDate();
        return yy + '年' + mm + '月' + dd + '日';
    },
}



// WEBPACK FOOTER //
// ./src/common/utils.js